import {
  TFilterSelected,
  TListingFetchReason,
  TREQUEST_ASSIGN_EMPLOYEE,
  TREQUEST_DELETE_LOCATION,
  TRESPONSE_FLOATING_AREAS_FOR_LOCATION_DELETION,
  TRESPONSE_GET_ASSSIGN_EMPLOYEE_DROPDOWN,
  TRESPONSE_GET_LOCAL_NEEDLE_STORES,
  TRESPONSE_LOCATION_LIST,
} from '@monorepo/types';
import { TLiftedFormModel, TUserPaginationOption } from '@monorepo/ui';
import { Action } from '@ngrx/store';
import { TLocationManagementActionType } from './location-management.models';
import { TSortingParameter } from 'libs/ui/src/lib/listing-sorter/sorter.types';

export class GetLocationListInfo implements Action {
  readonly type = TLocationManagementActionType.GetLocationList;
  constructor(
    public selectedFilters: TFilterSelected[] = [],
    public fetchReason: TListingFetchReason,
    public selectedSorting?: TSortingParameter,
  ) {}
}

export class GetLocationListInfoSuccess implements Action {
  readonly type = TLocationManagementActionType.GetLocationListSuccess;
  constructor(public locationListRes: TRESPONSE_LOCATION_LIST, public fetchReason: TListingFetchReason) {}
}

export class GetLocationListInfoFailure implements Action {
  readonly type = TLocationManagementActionType.GetLocationListFailure;
}

export class SetLocationListPagination implements Action {
  readonly type = TLocationManagementActionType.SetLocationListPagination;
  constructor(public pagination: TUserPaginationOption) {}
}

export class DeleteLocations implements Action {
  readonly type = TLocationManagementActionType.DeleteLocations;
  constructor(public payload: Omit<TREQUEST_DELETE_LOCATION, 'factoryId'>) {}
}

export class DeleteLocationsSuccess implements Action {
  readonly type = TLocationManagementActionType.DeleteLocationsSuccess;
}

export class DeleteLocationsFailure implements Action {
  readonly type = TLocationManagementActionType.DeleteLocationsFailure;
}

export class AssignEmployee implements Action {
  readonly type = TLocationManagementActionType.AssignEmployee;
  constructor(public payload: Omit<TREQUEST_ASSIGN_EMPLOYEE, 'factoryId'>) {}
}

export class AssignEmployeeSuccess implements Action {
  readonly type = TLocationManagementActionType.AssignEmployeeSuccess;
}

export class AssignEmployeeFailure implements Action {
  readonly type = TLocationManagementActionType.AssignEmployeeFailure;
}

export class GetAssignEmployeeDropdown implements Action {
  readonly type = TLocationManagementActionType.AssignEmployeeDropdown;
  constructor(public locationIds: TRESPONSE_LOCATION_LIST['locationDetails'][number]['id'][]) {}
}

export class GetAssignEmployeeDropdownSuccess implements Action {
  readonly type = TLocationManagementActionType.AssignEmployeeDropdownSuccess;
  constructor(public assignEmployeeDropdownRes: TRESPONSE_GET_ASSSIGN_EMPLOYEE_DROPDOWN) {}
}

export class GetAssignEmployeeDropdownFailure implements Action {
  readonly type = TLocationManagementActionType.AssignEmployeeDropdownFailure;
}

export class GetFloatingAreaFloorsForLocationDeletion implements Action {
  readonly type = TLocationManagementActionType.GetFloatingAreaFloorsForLocationDeletion;
}

export class GetFloatingAreaFloorsForLocationDeletionSuccess implements Action {
  readonly type = TLocationManagementActionType.GetFloatingAreaFloorsForLocationDeletionSuccess;
  constructor(public res: TRESPONSE_FLOATING_AREAS_FOR_LOCATION_DELETION) {}
}

export class GetFloatingAreaFloorsForLocationDeletionFailure implements Action {
  readonly type = TLocationManagementActionType.GetFloatingAreaFloorsForLocationDeletionFailure;
}

export class UpdateLocationManagementPageNo implements Action {
  readonly type = TLocationManagementActionType.UpdateLocationManagementPageNo;
  constructor(public page: number) {}
}

export class UpdateLocationManagementItemsPerPage implements Action {
  readonly type = TLocationManagementActionType.UpdateLocationManagementItemsPerPage;
  constructor(public itemsPerPage: number) {}
}

export class GetLocalNeedleStores implements Action {
  readonly type = TLocationManagementActionType.GetLocalNeedleStores;
}

export class GetLocalNeedleStoresSuccess implements Action {
  readonly type = TLocationManagementActionType.GetLocalNeedleStoresSuccess;
  constructor(public res: TRESPONSE_GET_LOCAL_NEEDLE_STORES) {}
}

export class GetLocalNeedleStoresFailure implements Action {
  readonly type = TLocationManagementActionType.GetLocalNeedleStoresFailure;
}

export class AssignNeedleStores implements Action {
  readonly type = TLocationManagementActionType.AssignNeedleStores;
  constructor(public payload: TLiftedFormModel['payload']) {}
}

export class AssignNeedleStoresSuccess implements Action {
  readonly type = TLocationManagementActionType.AssignNeedleStoresSuccess;
}

export class AssignNeedleStoresFailure implements Action {
  readonly type = TLocationManagementActionType.AssignNeedleStoresFailure;
}

export type TLocationManagementActions =
  | SetLocationListPagination
  | GetLocationListInfo
  | GetLocationListInfoSuccess
  | GetLocationListInfoFailure
  | DeleteLocations
  | DeleteLocationsSuccess
  | DeleteLocationsFailure
  | UpdateLocationManagementPageNo
  | UpdateLocationManagementItemsPerPage
  | AssignEmployee
  | AssignEmployeeSuccess
  | AssignEmployeeFailure
  | GetAssignEmployeeDropdown
  | GetAssignEmployeeDropdownSuccess
  | GetAssignEmployeeDropdownFailure
  | GetFloatingAreaFloorsForLocationDeletion
  | GetFloatingAreaFloorsForLocationDeletionSuccess
  | GetFloatingAreaFloorsForLocationDeletionFailure
  | GetLocalNeedleStores
  | GetLocalNeedleStoresSuccess
  | GetLocalNeedleStoresFailure
  | AssignEmployee
  | AssignEmployeeSuccess
  | AssignEmployeeFailure;
